module.exports = __webpack_public_path__ + "img/i_main_my_settop.f05866ed.svg";